
var projaddress = {
    container: null,

    init: function() {
        this.container = $('#projectaddresses');
        projaddress.register(this.container);
    },

    register: function(container) {
        initAutocompleter(container.find('.ctl-autocompleter'));
        container.find('[data-save]').click(function() {
            var row = $(this).parents('.d-flex[data-id]');
            projaddress.save(row);
        });
        container.find('[data-del]').click(function() {
            var row = $(this).parents('.d-flex[data-id]');
            var id = row.attr('data-id');
            if (id.length === 0) return;

            messaging.askYesNo('Addresszuweisung löschen?', 'Willst du diese Addresszuweisung löschen?', function() {
                projaddress.delete(row);
            });
        });
    },

    save: function(row) {
        var id = row.attr('data-id');
        row.find('.is-invalid').removeClass('is-invalid');
        var projectId = row.attr('data-projectId');
        var addressId = row.find('[name=AddressId]').val();
        var type = row.find('[name=Type]').val();
        debugger;
        if (addressId == null || addressId.length === 0) {
            row.find('.autocompleter-container').addClass('is-invalid');
            return;
        }
        if (type === "-") {
            row.find('.dd-container').addClass('is-invalid');
            return;
        }

        var task = {
            run: function(onComplete, onTaskError) {
                $.ajax({
                    url: '/Project/SaveProjectAddress',
                    data: {
                        Id: id,
                        ProjectId: projectId,
                        AddressId: addressId,
                        Type: type
                    },
                    timeout: connection.defaultTimeout,
                    type: 'post',
                    dataType: 'json',
                    success: function(data) {
                        messaging.showGlobalMessage("success", null, "Die Addresszuweisung wurde gespeichert.");
                        if (id === "") {
                            row.removeClass('isnew').attr('data-id', data.id);
                            row.find('.btn-group').removeClass('d-none');
                            //row.find('.btn-group .address-open').attr('href', row.find('.btn-group .address-open').attr('href').replace('/0', '/' + data.addressId));
                            var contentEl = $(data.emptyContent.trim());
                            contentEl.insertAfter(row);
                            projaddress.register(contentEl);
                        }
                        if (data.partnerContent !== "") {
                            var contentEl = $(data.partnerContent.trim());
                            contentEl.insertAfter(row);
                            projaddress.register(contentEl);
                        }
                        if (id === "") {
                            slidein.loadSlideIn('/Project/OwnerSlideIn/' + projectId);
                        }
                        connection.loadPart($('#project-addresses[data-loadPart]'));
                    },
                    error: function(data) {
                        if (data.statusText === 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError("Die Addresszuweisung konnte nicht gespeichert werden: " + connection.getErrorMessageOf(data, ''), false, function() {
                            //revert
                        });
                    },
                    complete: function() {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    },

    delete: function(row) {
        var id = row.attr('data-id');
        var task = {
            run: function(onComplete, onTaskError) {
                $.ajax({
                    url: '/Project/DeleteProjectAddress/' + id,
                    type: 'post',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    success: function() {
                        messaging.showGlobalMessage("success", null, "Die Addresszuweisung wurde gelöscht.");
                        row.remove();
                        connection.loadPart($('#project-addresses[data-loadPart]'));
                    },
                    error: function(data) {
                        if (data.statusText == 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError("Die Addresszuweisung konnte nicht gelöscht werden: " + connection.getErrorMessageOf(data, ''), false, function() {
                            //revert
                        });
                    },
                    complete: function() {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    }

};
window.projaddress = projaddress;
